import styled from 'vue3-styled-components';

export const ProductModalTitle = styled.h2`
  font-size: 1.5rem;
  color: #cc5803;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #fb8b24;
  text-align: center;
  `;

export const FormContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  padding: 10px;
`;

export const FormSection = styled.div`
    margin-right: 30px;
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    gap: 8px;
`;

export const RadioFormGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 5px;
    margin-bottom: 10px;
    gap: 8px;
`;

const labelProps = {
    required: Boolean
};

export const Label = styled('label', labelProps)`
    font-weight: bold;
    color: #333;
    font-size: 0.9rem;
    min-width: 80px;
    position: relative;
    
    ${props => props.required && `
        &:after {
            content: '*';
            color: #ff4444;
            margin-left: 4px;
            position: absolute;
        }
    `}
`;

export const SearchInputWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
`;

export const SearchButton = styled.button`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding-top: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    transition: all 0.2s ease;

    &:hover {
        color: #fb8b24;
    }

    .material-icons {
        font-size: 20px;
    }
`;

export const Input = styled.input`
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.9rem;
    width: 100%;
    
    &:focus {
        border-color: #0f4c5c;
        outline: none;
    }
`;

export const QuantityInput = styled.input`
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.9rem;
    max-width: 50px;
    
    &:focus {
        border-color: #0f4c5c;
        outline: none;
    }
`;

export const QuantityPieceInput = styled.input`
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.9rem;
    max-width: 70px;
    
    &:focus {
        border-color: #0f4c5c;
        outline: none;
    }
`;

export const PriceInput = styled.input`
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.9rem;
    max-width: 90px;
    
    &:focus {
        border-color: #0f4c5c;
        outline: none;
    }
`;

export const Select = styled.select`
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  max-width: 250px;
  
  &:focus {
    border-color: #0f4c5c;
    outline: none;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  & optgroup {
    color: #4a90e2;
    font-weight: 600;
  }

  & option {
    color: #333;
    font-weight: normal;
  }
`;

export const Textarea = styled.textarea`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  width: 100%;
  height: 100px;
  resize: vertical;
  
  &:focus {
    border-color: #0f4c5c;
    outline: none;
  }
`;

export const ProductAddNewSearchBtn = styled.button`
    background: #0f4c5c;
    height: 35px;
    padding: 0 10px;
    margin-left: 5px;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    
    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(-2px);
    }
`;

export const RadioGroup = styled.div`
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  flex: 1;
`;

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  font-size: 15px;
  margin-right: 10px;
  
  input[type="radio"] {
    width: 12px;
    height: 12px;
    margin: 0;
    cursor: pointer;
    
    &:checked {
      accent-color: #4a90e2;
    }
  }
`;

// * 이미지 업로드
export const FileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const FileInput = styled.input`
  display: none;
`;

export const CustomFileUpload = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #ccc; 
  padding: 1px 5px;
  background-color: #fb8b24;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  
  &:hover {
    background-color: #cc5803;
  }
`;

export const FileName = styled.span`
  color: #666;
  font-size: 0.9rem;
  max-width: 200px; // 파일명이 너무 길 경우 제한
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ImagePreview = styled.div`
  margin-left: 80px;
  width: 250px;
  height: 200px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain; // 이미지 비율 유지하면서 컨테이너에 맞춤
  }
`;

// * 해시태그
export const HashtagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
`;

export const HashtagItem = styled.div`
    display: inline-flex;
    align-items: center;
    background-color: #e8f0fe;
    color: #1a73e8;
    padding: 0.3rem 0.8rem;
    border-radius: 16px;
    font-size: 0.9rem;
    gap: 0.5rem;
`;

export const DeleteButton = styled.button`
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 0;
    font-size: 1.2rem;
    line-height: 1;
    
    &:hover {
        color: #ff4444;
    }
`;

// * 검색
export const SearchWrapper = styled.div`
    position: relative;
    flex: 1;
`;

export const CategoryPath = styled.div`
    font-size: 14px;
    color: #333;
    padding: 8px;

    &:hover {
        background-color: #f5f5f5;
    }
`;

export const SearchResults = styled.div`
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 300px;
    overflow-y: auto;
    z-index: 9999;
    width: 100%;
`;

export const SearchResultItem = styled.div`
    cursor: pointer;
    padding: 8px 12px;
    border-bottom: 1px solid #eee;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: #f5f5f5;
    }
`;

export const ItemName = styled.div`
    font-size: 0.9rem;
    color: #333;
    font-weight: 500;
`;

// ! 카드 인터페이스
export const Card = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    width: 368px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    min-height: 350px;
    max-height: 300px;
    
    &:hover {
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
    }
`;

export const CategoryCard = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    width: 368px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    min-height: 240px;
    max-height: 250px;
    
    &:hover {
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
    }
`;

export const SetCard = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    min-height: 610px;
    
    &:hover {
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
    }
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    background: #f8f9fa;
    border-bottom: 1px solid #eee;
    
    h3 {
        margin: 0;
        color: #333;
        font-size: 1.1rem;
        display: flex;
        align-items: center;
        gap: 8px;
        
        .material-icons {
            color: #fb8b24;
            font-size: 20px;
        }
    }
`;

export const CardBody = styled.div`
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 20px;
    overflow-y: auto;
`;

export const SetCardBody = styled.div`
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 20px;
`;

export const CardSection = styled.div`
    margin-bottom: 10px;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const StepContentWrapper = styled.div`
  display: flex;
  gap: 20px;
`;

export const StepColumn = styled.div`
  flex: ${props => {
    // 기본정보 컬럼인 경우 더 큰 flex 값 적용
    if (props.isBasicInfo) {
      return '1'; // 기본정보는 2배 크기
    }
    // 가격정보와 상세정보는 기본 크기
    return '1';
  }};
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-right: 2px solid #e0e0e0;
  padding-right: 24px;

  &:last-child {
    border-right: none;
    padding-right: 0;
  }
`;

export const StepColumnTitle = styled.div`
  font-size: 1.1rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
`;

// ! 카테고리 추가 버튼
export const AddCategoryButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 3px 8px;
    margin-top: 15px;
    margin-left: 10px;
    background: #0f4c5c;
    border: 1px solid #0f4c5c;
    border-radius: 5px;
    color: #fff;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background: #0f3c4c;
        color: white;
    }

    svg {
        margin-top: 3px;
    }
`;

export const CategoryButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 8px 20px;
  background-color: #0f4c5c;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  font-size: 15px;
  
  &:hover {
    background-color: #0f3c4c;
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;